// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';
import parse from 'html-react-parser';

import * as termsAndConditionsActions from '../store/actions';
import { getData } from '../store/selectors';
import Navigation from '../../../common/Navigation/Navigation';
import styles from './styles';

class TermsAndConditionsPage extends React.Component {
  state = {};

  componentDidMount() {
    this.props.requestPageData();
  }

  render() {
    const { classes, data } = this.props;
    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <div className={classes.subContainer}>
            <h4 className={classes.title}>{data.title}</h4>
            <div className={classes.htmlContainer}>
              {data.paragraphs.map(el => (
                <div key={uuidv4()}>
                  <span className={classes.subTitle}>{el.title.toUpperCase()}</span>
                  <div>{parse(el.text)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

TermsAndConditionsPage.propTypes = {
  classes: PropTypes.object,
  requestPageData: PropTypes.func,
  data: PropTypes.object,
};

TermsAndConditionsPage.defaultProps = {
  classes: {},
  requestPageData: () => { },
  data: {
    paragraphs: [],
  },
};

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestPageData: () => dispatch(termsAndConditionsActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TermsAndConditionsPage));
